import React, { useEffect } from "react";
import HpglLogo from "../../assets/Hpgl-logo-dark.png";
import HPGLText from "../../assets/HPGL-text-white-transparent-background.png";
import { Busy } from "../Busy";
import { Link } from "react-router-dom";
import { Button } from "../catalyst/button";
import { usePublicStore } from "../../store/publicStore";

const MainPageLayout: React.FC<any> = ({
  children,
  isBusy,
  busyMessage,
  Footer,
}) => {
  const { currentSeason, getCurrentSeason } = usePublicStore();

  useEffect(() => {
    if (!currentSeason) {
      getCurrentSeason();
    }
  }, [getCurrentSeason, currentSeason]);

  return (
    <div
      className="bg-dark-hpgl"
      style={{ height: "calc(100vh)", overflow: "auto" }}
    >
      <div className="px-4 fixed top-0 left-0 w-full z-10 bg-emerald-800">
        <div className="flex justify-between pt-2">
          <div className="flex items-center gap-2">
            <img alt="HPGL" src={HpglLogo} className="h-8 w-10" />
            <img alt="HPGL" src={HPGLText} className="h-6 w-32" />
          </div>

          <div className="flex items-center gap-2 justify-center w-full">
            {currentSeason?.sponsors?.map((sponsor: any) => (
              <a
                key={sponsor.id}
                href={sponsor.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  alt={sponsor.name}
                  src={`/api/static/images/${sponsor.logo}`}
                  className="w-full object-contain max-h-[40px]"
                />
              </a>
            ))}
          </div>
          <div className="flex gap-x-1">
            <Link to="/register">
              <Button
                className="w-[75px] rounded-sm !text-white !h-6 border-0"
                outline
              >
                <span>Register</span>
              </Button>
            </Link>
            <Link to="/login">
              <Button
                className="w-[55px] rounded-sm !text-white !h-6 border-0"
                outline
              >
                <span>Login</span>
              </Button>
            </Link>
          </div>
        </div>

        <div className="flex justify-center gap-0">
          <Link to="/leaderboard">
            <Button className="!px-1 rounded-sm !text-white border-0" outline>
              <span>Leaderboard</span>
            </Button>
          </Link>
          <Link to="/">
            <Button className="!px-1 rounded-sm !text-white border-0" outline>
              <span>Schedule</span>
            </Button>
          </Link>
          <Link to="/fixtures">
            <Button className=" !px-1 rounded-sm !text-white border-0" outline>
              <span>Fixtures</span>
            </Button>
          </Link>
          <Link to="/teams">
            <Button className=" !px-1 rounded-sm !text-white border-0" outline>
              <span>Teams</span>
            </Button>
          </Link>
        </div>
      </div>
      <div className="m-4 mt-[90px] mb-[55px] ">
        <div className="flex flex-col items-center">{children}</div>
      </div>
      {isBusy && (
        <Busy busyMessage={busyMessage ? busyMessage : "Please wait..."} />
      )}
      <div className="container-shell-footer dark:bg-gray-800 p-1 left-0">
        <div className="w-full flex items-center justify-center flex-wrap">
          {Footer}
          <span className="m-0 text-xs text-gray-700 dark:text-gray-300">
            v{__APP_VERSION__}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MainPageLayout;
